import type {CreateToastReturnFn} from '@deezer/next/shared/hooks/useToast';
import type {ButtonProps} from '@tempo/core';

export enum ConfigKeys {
	API_HOST = 'API_HOST',
	LEGACY_API_HOST = 'LEGACY_API_HOST',
	RESET_CSS = 'RESET_CSS',
	LOCALE = 'LOCALE',
	TOAST_INFO = 'TOAST_INFO',
	TOAST_WARNING = 'TOAST_WARNING',
	TOAST_ERROR = 'TOAST_ERROR',
	THEME_MODE = 'THEME_MODE',
	RESET_DIDOMI = 'RESET_DIDOMI',
	FORCE_SHOW_DIDOMI_BANNER = 'FORCE_SHOW_DIDOMI_BANNER',
	DISABLE_TOAST = 'DISABLE_TOAST',
	DISABLE_THUMBNAILS = 'DISABLE_THUMBNAILS',
}

export type SelectInput = {
	type: 'select';
	label: string;
	options: {label: string; value: string}[];
	defaultValue: string;
	onSelect?: (value: string) => void;
	placeholder?: string;
};

export type ToolButton = {
	type: 'button';
	label: string;
	defaultValue?: string;
	onClick?: ({toast}: {toast: CreateToastReturnFn}) => void;
	buttonProps?: Omit<ButtonProps, 'onClick'>;
};

export type ConfigValue = (
	| {
			type: 'string' | 'boolean';
			label: string;
			defaultValue?: string;
			groupId?: string;
	  }
	| SelectInput
	| ToolButton
) & {groupId?: string};

export type Config = {[key in ConfigKeys]: string};

export type BooleanConfigKeys =
	| ConfigKeys.RESET_CSS
	| ConfigKeys.DISABLE_TOAST
	| ConfigKeys.DISABLE_THUMBNAILS;

export type ToolsStorage = {
	setConfigValue: <T extends ConfigKeys>(
		key: T,
		value: T extends BooleanConfigKeys ? boolean : string,
	) => void;
	getConfigValue: <T extends ConfigKeys>(
		key: T,
	) => T extends BooleanConfigKeys ? boolean : string;
	getConfig: () => Config;
};
